const EMPTY_APP_STATE_VALUE = '{{data_app_state}}';

const shouldFetchStateApi = () =>
  document.body.getAttribute('data-app-state') === EMPTY_APP_STATE_VALUE;

export default shouldFetchStateApi;
